<div class="modal_dialog substitute-products-modal">
  <div class="modal_header">
    <h2>{{ "SuggestSubstitute" | translate }}</h2>
    <span class="order-badge">#{{ data.orderNo }}</span>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="substitute-layout">
      <!-- Left Section: Product Grid -->
      <div class="products-section">
        <!-- Action Bar -->
        <div class="action-bar">
          <div class="action-buttons">
            <button class="btnn btn_accept" (click)="acceptOrder()">
              <i class="fa fa-check"></i>
              {{ "AcceptOrder" | translate }}
            </button>
            <button 
              class="btnn btn_substitute" 
              [disabled]="selectedProducts.length === 0"
              (click)="sendSubstituteNotification()">
              <i class="fa fa-exchange-alt"></i>
              {{ "SendSubstitute" | translate }}
            </button>
          </div>
          <div class="search-box">
            <i class="fa fa-search search-icon"></i>
            <input 
              type="text" 
              [formControl]="searchControl"
              [placeholder]="'SearchProducts' | translate"
              class="search-input">
          </div>
        </div>

        <!-- Original Product Info -->
        <div class="original-product-card" *ngIf="data.originalProduct">
          <div class="original-label">{{ "OriginalOrder" | translate }}</div>
          <div class="original-content">
            <img [src]="data.originalProduct.image || 'assets/images/product-placeholder.png'" 
                 [alt]="data.originalProduct.productName" 
                 class="original-image">
            <div class="original-info">
              <h4>{{ data.originalProduct.productName }}</h4>
              <p>{{ "Quantity" | translate }}: {{ data.originalProduct.quantity }}</p>
            </div>
          </div>
        </div>

        <!-- Products Grid -->
        <div class="products-grid-container">
          <div class="products-grid" *ngIf="!isLoading && filteredProducts.length > 0">
            <div 
              class="product-card" 
              *ngFor="let product of filteredProducts"
              [class.selected]="product.isSelected"
              (click)="toggleProductSelection(product)">
              <div class="product-checkbox">
                <mat-icon *ngIf="product.isSelected">check_circle</mat-icon>
                <mat-icon *ngIf="!product.isSelected">radio_button_unchecked</mat-icon>
              </div>
              <div class="product-image-wrapper">
                <img [src]="getProductImage(product)" [alt]="product.productName">
              </div>
              <div class="product-details">
                <h4 class="product-name">{{ product.productName }}</h4>
                <!-- <p class="product-sku">SKU: {{ product.selectedVariant?.sku || product.sku || '---' }}</p>
                <p class="product-category" *ngIf="product.category?.name">
                  {{ product.category?.name || '---' }}
                </p> -->
                <div class="product-price">{{ getProductPrice(product) | customCurrency }}</div>
                
                <!-- Variant Selector -->
                <div class="variant-selector" *ngIf="product.variants && product.variants.length > 1" (click)="$event.stopPropagation()">
                  <select 
                    class="variant-select-native"
                    [value]="product.selectedVariant?._id"
                    (change)="selectVariantNative($event, product)">
                    <option value="" disabled>{{ "SelectVariant" | translate }}</option>
                    <option *ngFor="let variant of product.variants" [value]="variant._id" [selected]="product.selectedVariant?._id === variant._id">
                      {{ variant.variantName }} - {{ variant.sellingPrice | customCurrency }}
                    </option>
                  </select>
                </div>

                <!-- Quantity Control -->
                <div class="quantity-control" *ngIf="product.isSelected" (click)="$event.stopPropagation()">
                  <button class="qty-btn" (click)="updateSelectedProductQuantity(product, -1)">
                    <i class="fa fa-minus"></i>
                  </button>
                  <span class="qty-value">{{ product.quantity }}</span>
                  <button class="qty-btn" (click)="updateSelectedProductQuantity(product, 1)">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div class="loading-state" *ngIf="isLoading">
            <div class="spinner"></div>
            <p>{{ "LoadingProducts" | translate }}...</p>
          </div>

          <!-- Empty State -->
          <div class="empty-state" *ngIf="!isLoading && filteredProducts.length === 0">
            <i class="fa fa-box-open empty-icon"></i>
            <p>{{ "NoProductsFound" | translate }}</p>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-controls" *ngIf="totalPages > 1">
          <button 
            class="page-btn" 
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)">
            <i class="fa fa-chevron-left"></i>
          </button>
          <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
          <button 
            class="page-btn" 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <!-- Right Section: Selected Products -->
      <div class="selected-section">
        <div class="selected-header">
          <h3>
            <i class="fa fa-shopping-cart"></i>
            {{ "SelectedSubstitutes" | translate }}
            <span class="count-badge" *ngIf="selectedProducts.length > 0">{{ selectedProducts.length }}</span>
          </h3>
          <button 
            class="clear-all-btn" 
            *ngIf="selectedProducts.length > 0"
            (click)="clearAllSelected()">
            {{ "ClearAll" | translate }}
          </button>
        </div>

        <div class="selected-products-list" *ngIf="selectedProducts.length > 0">
          <div class="selected-product-item" *ngFor="let product of selectedProducts">
            <img [src]="getProductImage(product)" [alt]="product.productName" class="selected-product-image">
            <div class="selected-product-info">
              <h5 class="selected-product-name">{{ product.productName }}</h5>
              <p class="selected-variant" *ngIf="product.selectedVariant">
                {{ product.selectedVariant.variantName }}
              </p>
              <div class="selected-product-meta">
                <span class="selected-price">{{ getProductPrice(product) | customCurrency }}</span>
                <span class="selected-qty">x{{ product.quantity }}</span>
              </div>
            </div>
            <button class="remove-btn" (click)="removeFromSelected(product)">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

        <div class="empty-selected" *ngIf="selectedProducts.length === 0">
          <i class="fa fa-clipboard-list empty-icon"></i>
          <p>{{ "NoProductsSelected" | translate }}</p>
          <span class="hint">{{ "SelectProductsHint" | translate }}</span>
        </div>

        <!-- Summary Footer -->
        <div class="selected-footer" *ngIf="selectedProducts.length > 0">
          <div class="summary-row">
            <span>{{ "TotalItems" | translate }}:</span>
            <span class="summary-value">{{ selectedProducts.length }}</span>
          </div>
          <button 
            class="btnn btn_send_notification"
            (click)="sendSubstituteNotification()">
            <i class="fa fa-paper-plane"></i>
            {{ "SendNotification" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

